var _path, _circle, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4298 21.6632C37.3741 29.7722 30.3912 35.1689 22.1562 36.1791C13.9211 37.1894 7.55246 33.4306 6.60816 25.3216C5.66387 17.2126 5.287 6.33636 13.522 5.32611C21.7571 4.31586 35.4855 13.5542 36.4298 21.6632Z",
    fill: "#EEF0FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3787,
    cy: 20.7342,
    r: 2.35925,
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4656 27.812C20.4931 27.6194 20.5074 27.4224 20.5074 27.2222C20.5074 24.942 18.6589 23.0935 16.3787 23.0935C14.0985 23.0935 12.25 24.942 12.25 27.2222C12.25 27.4224 12.2643 27.6194 12.2918 27.812",
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 26.2111H26.8854",
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 23.5861H29.6334",
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 21H29.6334",
    stroke: "#1E3269",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8734 11.3734H9.78119C9.21168 11.3734 8.75 11.835 8.75 12.4046V31.4003C8.75 31.9698 9.21168 32.4315 9.78119 32.4315H32.0764C32.6459 32.4315 33.1076 31.9698 33.1076 31.4003V12.4046C33.1076 11.835 32.6459 11.3734 32.0764 11.3734H26.9842M14.8734 11.3734V13.4608C14.8734 13.5747 14.9657 13.667 15.0796 13.667H26.778C26.8919 13.667 26.9842 13.5747 26.9842 13.4608V11.3734M14.8734 11.3734V10.4022C14.8734 10.2883 14.9657 10.1959 15.0796 10.1959H17.7329C17.845 9.13061 18.4057 7 20.9288 7C23.6201 7 23.9565 9.18668 23.9565 10.0277C24.4516 10.0277 25.9332 10.0277 26.7785 10.0277C26.8924 10.0277 26.9842 10.1201 26.9842 10.234V11.3734",
    stroke: "#1E3269",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.965f605ba36bffe12d2bb13ad9aad443.svg";
export { ForwardRef as ReactComponent };